import { getRaw } from 'services/api';

export const CUSTOM_EVENT_MANAGEMENT_URL = '/usagemetrics/joinedEventData';

/**
 * Fetch the Custom Event Management data
 */
export const getCustomEvents = (queryString: string) => {
  const requestUrl = queryString
    ? CUSTOM_EVENT_MANAGEMENT_URL + queryString
    : CUSTOM_EVENT_MANAGEMENT_URL;
  return getRaw(requestUrl);
};
